import React, { useEffect, useState } from "react";
import "./OTPSuccessVerification.css";
import { FaCheck } from "react-icons/fa6";
import { Strings } from "../../../../utils/strings";
import { ACCESS_TOKEN } from "../../../../utils/constants";
import { useWebChat } from "../../../../context/webChatContext";
import LoadingIndicator from "../../../loadingIndicator/LoadingIndicator";

type props = {
  authToken?: string;
};

export const OTPSuccessVerification: React.FC<props> = ({ authToken }) => {
  const { fetchMe } = useWebChat();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (authToken) {
      // setLoading(true);
      setTimeout(async () => {
        localStorage.setItem(ACCESS_TOKEN, authToken);
        await fetchMe();
        setLoading(false);
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken]);

  return (
    <div className="mobile-otp-success-container">
      <div className="mobile-otp-success-circle">
        <FaCheck color="white" size={30} />
      </div>
      <span className="mobile-otp-success-thanks">{Strings.THANK_YOU}</span>
      <span className="mobile-otp-success-desc">{Strings.OTP_VERIFIED}</span>
      {loading && <LoadingIndicator loading />}
    </div>
  );
};
